<template>
  <Dropdown
    class-name="session-own-deliverables"
    :title="t('session.ownDeliverables.title')"
    :default-open="false"
    :is-loaded="!isPendingRef && !isDeliverablesPendingRef"
    data-test-id="session-own-deliverables"
  >
    <template v-if="sessionRef && deliverablesRef && deliverablesRef.length > 0">
      <div class="deliverables-listing" v-if="accountRef?.id">
        <div class="deliverable-card no-actions">
          <div class="deliverables-list">
            <template
              v-if="
                returnDeliverableByUserId({
                  deliverables: deliverablesRef,
                  menteeId: accountRef.id,
                })?.folder?.files
              "
            >
              <Deliverable
                v-for="file in returnDeliverableByUserId({
                  deliverables: deliverablesRef,
                  menteeId: accountRef.id,
                })?.folder?.files"
                :key="file?.id"
                :session-id="sessionIdRef"
                :user-id="accountRef.id"
                :file="file"
              />
            </template>
            <template v-else>
              <EmptyContent :text="t('session.deliverables.noDeliverable')" />
            </template>
          </div>
        </div>
        <div class="c-btns-container c-btn-center">
          <CustomButton
            usage="button"
            color="primary"
            :text="t('session.ownDeliverables.modifyDeliverables')"
            data-test-id="modify-deliverables"
            @emit:click="onClickModifyDeliverable"
          >
            <template #icon>
              <EditIcon color="white" />
            </template>
          </CustomButton>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import useAccount from '@/features/auth/hooks/use-account.hook'
import Deliverable from '@/features/sessions/components/deliverable/deliverable.vue'
import useDeliverables from '@/features/sessions/hooks/use-deliverables.hook'
import useSession from '@/features/sessions/hooks/use-session.hook'
import { returnDeliverableByUserId } from '@/features/sessions/utils'
import CustomButton from '@/features/ui/components/button/custom-button.vue'
import Dropdown from '@/features/ui/components/dropdown/dropdown.vue'
import EmptyContent from '@/features/ui/components/empty-content/empty-content.vue'
import EditIcon from '@/features/ui/components/icons/edit-icon.vue'
import { selectGetSessionDetailsModal } from '@/features/ui/store/modal/modal.selectors'
import type { ReviewSessionModalType } from '@/features/ui/store/modal/modal.store'
import modalsStore from '@/features/ui/store/modal/modal.store'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()

const sessionDetailsModalRef = selectGetSessionDetailsModal(modalsStore)

const sessionIdRef = computed(() => sessionDetailsModalRef.value.attachedData.sessionId ?? null)

const { sessionRef, isPendingRef } = useSession(sessionIdRef)

const { accountRef } = useAccount()

const { deliverablesRef, isPendingRef: isDeliverablesPendingRef } = useDeliverables(sessionIdRef)

const onClickModifyDeliverable = () => {
  modalsStore.toggleModal('review-session', true)
  modalsStore.toggleModal('session-details', false)

  modalsStore.setModalStep<ReviewSessionModalType>('review-session', 'deliverable')
  modalsStore.updateModalAttachedData<ReviewSessionModalType>('review-session', {
    sessionId: sessionIdRef.value!,
  })
}
</script>

<style lang="scss">
@import './session-own-deliverables.scss';
</style>
